/**
 * Returns new object with no methods or undefined properties.
 */
export const prune = (obj: object) => {
    const out = JSON.parse(JSON.stringify(obj || 'null'))
    Object.keys(out).forEach((k) =>
        (out[k] === null || out[k] === undefined || out[k] instanceof Function) && delete out[k])
    return out
}
